<template>
  <b-card class="bg-white rounded-xl p-4 px-2 py-2">
    <div class="flex items-center pb-4">
      <div
        class="mr-2 flex gap-1 cursor-pointer"
        @click="handleClick('admin-brochure')"
      >
        <ChevronLeftIcon />
        <h2 class="text-2xl font-medium text-3d3d3d">Back</h2>
      </div>
    </div>
    <h2 class="text-2xl font-medium text-3d3d3d">Uploaded Document</h2>
    <iframe
      v-if="borach_details.file"
      :src="$imageURL + '/' + borach_details.file"
      frameborder="0"
      width="50%"
      height="50%"
    ></iframe
    ><br />
    <button
      v-if="borach_details.file"
      type="danger"
      class="text-l font-medium text-3d3d3d text-danger"
      :color="red"
      @click="reset2"
    >
      Remove Document
    </button>

    <el-form role="form">
      <div class="mb-8 pt-4">
        <el-input
          type="text"
          v-model="datainfo.title"
          class=""
          placeholder="Title"
        />
        <span v-if="nameErr" class="small text-danger">{{ msg.name }}</span>
      </div>

      <div class="my-6">
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
          :accept="'application/pdf, .pdf'"
        />
      </div>
      <iframe :src="image" v-if="image" frameborder="0"></iframe>
      <div class="flex cursor-pointer items-center my-2" v-if="image">
        <button
          type="danger"
          class="text-l font-medium text-3d3d3d text-danger"
          @click="reset"
        >
          Remove Document
        </button>
      </div>
      <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
      <div>
        <div class="text-center py-4">
          <button
            class="bg-primary px-10 py-2 rounded text-white text-l"
            native-type="submit"
            @click.prevent="onSubmit()"
          >
            Save
          </button>
        </div>
      </div>
    </el-form>
  </b-card>
</template>

<script>
// import { VueEditor } from "vue2-editor";

import _ from "lodash";
import { ChevronLeftIcon } from "vue-feather-icons";
import { mapState } from "vuex";
import FileUploader from "@/components/FileUploader";
export default {
  components: {
    ChevronLeftIcon,
    FileUploader,
  },
  data() {
    return {
      title: "",
      image: null,
      coverImage: null,
      datainfo: {},
      file: null,
      editorOption: {
        theme: "snow",
      },
      imageErr: false,
      nameErr: false,
      msg: {},
    };
  },
  methods: {
    async reset2() {
      this.borach_details.file = null;
    },
    async reset() {
      this.title = "";
      this.image = null;
    },
    handleSuccess(image) {
      this.imageErr = false;
      if (!image.type.includes("application")) {
        this.imageErr = true;
        this.msg.image = "Upload PDF File Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));
      };
      reader.readAsDataURL(rawFile);
    },
    init() {
      this.datainfo = this.borach_details;
    },
    async onSubmit() {
      if (this.datainfo.title.trim() == "") {
        this.nameErr = true;
        this.msg.name = "Title is required";
        return;
      }
      if (!this.coverImage && !this.borach_details.file) {
        this.imageErr = true;
        this.msg.image = "Please select an image";
        return;
      }
      let FormData = require("form-data");
      let payload = new FormData();

      payload.append("title", this.datainfo.title);
      if (!this.coverImage) {
        payload.append("file", this.borach_details.file);
      } else {
        payload.append("file", this.coverImage);
      }
      payload.append("_id", this.borach_details._id);
      try {
        let editdata = await this.$store.dispatch(
          "coach/EditBrochure",
          payload
        );
        // let editdata = await this.$store.dispatch("coach/GetBrochure");
        this.$router.push({ name: "admin-brochure" });
        if (editdata.code == 200) {
          this.$swal.fire({
            text: "Successfully edited Brochure",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.reset();
          this.reset2();
        }
      } catch (err) {}
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  computed: {
    ...mapState("coach", {
      borach_details: "borach_details",
    }),
  },
  mounted() {
    this.init();
  },
};
</script>
